export const safeTranslate = (t, key, fallback, options = {}) => {
  const value = t(key, { defaultValue: fallback, ...options });
  return value && value !== key ? value : fallback;
};
